import type { ReactElement } from "react"

export default function Trustpilot(): ReactElement {
  return (
    <div className="flex items-center justify-center md:justify-start">
      {/* Trustpilot widget will be integrated here */}
      <div id="trustpilot-widget" />
    </div>
  )
}
